export default __webpack_public_path__ + "static/media/qr-code.1f0b08a8.svg";